import { Typography } from '@mui/material';
import { t } from 'i18next';

const MobileUpsellTitle: React.FC = () => (
  <Typography
    sx={{
      textAlign: 'center',
      justifySelf: 'center',
    }}
    variant='p30Bold'
    color='primary'
    mb={'20px'}>
    {t('YourSmartPortfolio')}
  </Typography>
);

export default MobileUpsellTitle;
